@let state = verifyPhoneModalState();
@let vm = state.viewModel;

@let verifyCodeFormControl = state.verifyCodeFormControl;
@let isInvalidForm = !verifyCodeFormControl.valid;
@let isVerificationCodeEntered = !!verifyCodeFormControl.value.length;

@let verifyPhoneDescriptionTranslationKey = 'verify-phone.modal.description';
@let verifyPhoneDescriptionTranslation =
  verifyPhoneDescriptionTranslationKey | translate | hideTranslation | wysiwyg | safeHtml;
@let verifyPhoneErrorMessageTranslationKey = 'verify-phone.modal.error-message.confirm-verification-code';
@let verifyPhoneErrorMessageTranslation = verifyPhoneErrorMessageTranslationKey | translate | hideTranslation;
@let verifyPhoneResendErrorMessageTranslationKey = 'verify-phone.modal.error-message.resend-verification-code';
@let verifyPhoneResendErrorMessageTranslation =
  verifyPhoneResendErrorMessageTranslationKey | translate | hideTranslation;

<ls-modal
  data-nested-translation="verify-phone.modal.heading"
  [title]="'verify-phone.modal.heading' | translate | hideTranslation"
  [visible]="vm.isVerifyPhoneModalOpen"
  [footerContent]="false"
  (onClose)="onCloseModalWindow()"
>
  <div class="flex flex-column gap-3">
    @if (verifyPhoneDescriptionTranslation) {
      <div
        class="text-center"
        [attr.data-nested-translation]="verifyPhoneDescriptionTranslationKey"
        [innerHTML]="verifyPhoneDescriptionTranslation"
      ></div>
    }

    <ls-input-text
      class="flex justify-content-center"
      data-nested-translation="verify-phone.modal.input.verification-code.label"
      appNumbersOnlyInput
      [id]="'verify-code'"
      [type]="'text'"
      [title]="'verify-phone.modal.input.verification-code.label' | translate | hideTranslation"
      [placeholder]="'verify-phone.modal.input.verification-code.placeholder' | translate | hideTranslation"
      [size]="'lg'"
      [autocomplete]="'off'"
      [formControl]="verifyCodeFormControl"
      [showErrorMessages]="false"
    />

    @if (vm.isVerifyPhoneError && verifyPhoneErrorMessageTranslation) {
      <ls-message
        [attr.data-nested-translation]="verifyPhoneErrorMessageTranslationKey"
        [icon]="'la-exclamation-triangle'"
        [severity]="'error-inline'"
        [message]="verifyPhoneErrorMessageTranslation"
        [closable]="false"
        [escape]="true"
      />
    }

    @if (vm.isVerifyPhoneResendError && verifyPhoneResendErrorMessageTranslation) {
      <ls-message
        [attr.data-nested-translation]="verifyPhoneResendErrorMessageTranslationKey"
        [icon]="'la-exclamation-triangle'"
        [severity]="'error-inline'"
        [message]="verifyPhoneResendErrorMessageTranslation"
        [closable]="false"
        [escape]="true"
      />
    }

    <div class="flex flex-wrap justify-content-center gap-1">
      <ls-button
        data-nested-translation="verify-phone.modal.button.confirm-verification-code"
        [styleClass]="'button-primary'"
        [color]="'primary'"
        [size]="'md'"
        [label]="'verify-phone.modal.button.confirm-verification-code' | translate | hideTranslation"
        [disabled]="isInvalidForm"
        [loading]="vm.isVerifyPhoneProcessing"
        (onClick)="onVerifyPhone($event)"
      />

      <ls-button
        data-nested-translation="verify-phone.modal.button.resend-verification-code"
        [styleClass]="'button-primary'"
        [color]="'primary'"
        [size]="'md'"
        [label]="'verify-phone.modal.button.resend-verification-code' | translate | hideTranslation"
        [disabled]="isVerificationCodeEntered"
        [loading]="vm.isVerifyPhoneResendProcessing"
        (onClick)="onVerifyPhoneResend($event)"
      />
    </div>
  </div>
</ls-modal>
